import { BrowserCacheLocation } from '@azure/msal-browser';

export const environment = {
    production: true,
    fileUrl: 'https://files.dev.interviewguide.siemens-healthineers.com',
    msalConfig: {
        auth: {
            clientId: 'adc58a81-ab62-450f-8e87-700c1977f373',
            authority: 'https://login.microsoftonline.com/5dbf1add-202a-4b8d-815b-bf0fb024e033',
            redirectUri: window.location.origin,
            postLogoutRedirectUri: window.location.origin,
            navigateToLoginRequestUrl: true
        },
        cache: {
            cacheLocation: BrowserCacheLocation.SessionStorage,
            storeAuthStateInCookie: false
        },
        system: {
            allowPlatformBroker: false
        }
    },
    apiConfig: [
        {
            scopes: ['openid', 'profile', 'email', 'offline_access'],
            uri: 'https://graph.microsoft.com/v1.0'
        },
        {
            scopes: ['api://9548d8c3-608a-4d83-a2ef-3e7b089546c8/Api.ReadWrite'],
            uri: 'https://files.dev.interviewguide.siemens-healthineers.com/*'
        }
    ]
};
